<template>
  <b-row>
    <b-col
      cols="12"
    >
      <form-wizard
        ref="refWizard"
        color="#fdb813"
        :title="null"
        :subtitle="null"
        next-button-text="Volgende"
        back-button-text="Terug"
        finish-button-text="Offerte aanvragen"
        layout="vertical"
        class="wizard-vertical mb-3"
        @on-complete="formSubmitted"
        @on-change="scrollToTop"
      >
        <tab-content
          title="Reisverzekering"
          icon="feather icon-user"
          :before-change="validationInformationForm"
        >
          <validation-observer
            ref="information"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Reisverzekering
                </h5>
                <small>
                  Bereken hier je (indicatieve) premie.
                </small>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="dateFrom"
                  rules="required"
                >
                  <b-form-group
                    label="Vertrek op"
                    label-for="dateFrom"
                  >
                    <flat-pickr
                      id="dateFrom"
                      v-model="calculation.dateFrom"
                      :config="dateFromConfig"
                      :state="getValidationState(validationContext)"
                      placeholder="dd-mm-jjjj"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="dateTill"
                  rules="required"
                >
                  <b-form-group
                    label="Terug op"
                    label-for="dateTill"
                  >
                    <flat-pickr
                      id="dateTill"
                      :key="dateTillConfig.key"
                      v-model="calculation.dateTill"
                      :config="dateTillConfig"
                      :state="getValidationState(validationContext)"
                      placeholder="dd-mm-jjjj"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="destination"
                  rules="required"
                >
                  <b-form-group
                    label="Bestemming"
                    label-for="destination"
                  >
                    <VueRadioButton
                      v-model="calculation.destination"
                      :options="destinationButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
        <tab-content
          title="Personen"
          icon="feather icon-users"
          :before-change="validationPersonForm"
        >
          <validation-observer
            ref="birthDates"
            tag="form"
          >
            <div
              ref="formBirthDate"
              class="repeater-form mb-1"
              :style="{height: trHeightBirthDate}"
            >
              <b-row>
                <b-col
                  cols="8"
                  class="mb-2"
                >
                  <h5 class="mb-0">
                    Personen
                  </h5>
                </b-col>
                <b-col
                  cols="4"
                  class="mb-2"
                  style="text-align: right"
                >
                  <b-badge
                    variant="primary"
                    style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                    @click="resetForm"
                  >
                    <feather-icon
                      icon="RefreshCcwIcon"
                      size="18"
                    />
                  </b-badge>
                </b-col>
                <!-- Item Form -->
                <!-- ? This will be in loop => So consider below markup for single item -->
                <b-col cols="12">
                  <div class="mr-2 mb-2">
                    <b-row>
                      <b-col
                        class="d-flex align-items-end justify-content-end"
                        aling-self="end"
                        cols="12"
                        md="12"
                      >
                        <b-button
                          variant="secondary"
                          @click="addPerson"
                        >
                          <feather-icon
                            class="cursor-pointer mr-1"
                            icon="UserPlusIcon"
                            size="16"
                            variant="secondary"
                          />
                          Persoon toevoegen
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    v-for="(item, index) in calculation.birthDates"
                    :key="`birthDates-${index}`"
                    ref="rowBirthDates"
                    class="d-flex border rounded mb-1"
                  >
                    <b-row
                      class="flex-grow-1 p-2"
                    >
                      <!-- Single Item Form Headers -->
                      <b-col
                        cols="12"
                        md="11"
                      >
                        <label class="d-inline d-md-none">Geboortedatum</label>
                        <validation-provider
                          #default="validationContext"
                          :name="`birthDate${index}`"
                          rules="required"
                        >
                          <b-form-group
                            :label="`Geboortedatum persoon ${index + 1}`"
                            label-for="birthDate"
                            :state="getValidationState(validationContext)"
                          >
                            <flat-pickr
                              :id="`birthDate${index}`"
                              v-model="item.birthDate"
                              :config="birthDateConfig"
                              :state="getValidationState(validationContext)"
                              placeholder="dd-mm-jjjj"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <div
                      class="d-flex flex-column justify-content-between border-left py-50 px-25"
                      style="min-width: 20px"
                    >
                      <feather-icon
                        v-if="0 !== index || calculation.birthDates.length > 1"
                        size="16"
                        icon="TrashIcon"
                        class="cursor-pointer"
                        @click="removeInvoiceLine(index)"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </validation-observer>
        </tab-content>
        <tab-content
          title="Premie"
          icon="feather icon-link"
        >
          <b-row>
            <b-col
              cols="8"
              class="mb-2"
            >
              <h5 class="mb-0">
                Premie
              </h5>
            </b-col>
            <b-col
              cols="4"
              class="mb-2"
              style="text-align: right"
            >
              <b-badge
                variant="primary"
                style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                @click="resetForm"
              >
                <feather-icon
                  icon="RefreshCcwIcon"
                  size="18"
                />
              </b-badge>
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <b-card
                no-body
                class="card-apply-job"
              >
                <div
                  class="apply-job-package bg-light-primary rounded"
                  style="border-bottom-right-radius:0 !important;border-bottom-left-radius:0 !important;"
                >
                  <div>
                    <sup class="text-body">
                      <small>{{ calculation.currency }}</small>
                    </sup>
                    <h2 class="d-inline mr-25">
                      {{ calculation.premium }}
                    </h2>
                    <!--                    <sub class="text-body"><small>/ month</small></sub>-->
                  </div>
                  <b-badge
                    variant="light-primary"
                    pill
                  >
                    indicatie
                  </b-badge>
                </div>
                <b-card-body>
                  <b-card-text class=" ml-0 mr-0 pl-0 pr-0 mb-2">
                    <ul class=" ml-0 mr-0 pl-0 pr-0">
                      <li>De premie is exclusief USD\EUR 2,50 voor poliskosten.</li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content
          title="Offerte"
          icon="feather icon-map-pin"
        >
          <validation-observer
            ref="offer"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Adres
                </h5>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="firstName"
                  rules="required"
                >
                  <b-form-group
                    label="Voornaam"
                    label-for="firstName"
                  >
                    <b-form-input
                      id="firstName"
                      v-model="calculation.firstName"
                      :state="getValidationState(validationContext)"
                      trim
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="lastName"
                  rules="required"
                >
                  <b-form-group
                    label="Achternaam"
                    label-for="lastName"
                  >
                    <b-form-input
                      id="lastname"
                      v-model="calculation.lastName"
                      :state="getValidationState(validationContext)"
                      trim
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!--              <b-col-->
              <!--                cols="12"-->
              <!--                md="8"-->
              <!--              >-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="street"-->
              <!--                  rules="required"-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="Straatnaam"-->
              <!--                    label-for="street"-->
              <!--                  >-->
              <!--                    <b-form-input-->
              <!--                      id="street"-->
              <!--                      v-model="calculation.street"-->
              <!--                      :state="getValidationState(validationContext)"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <!--              <b-col-->
              <!--                cols="12"-->
              <!--                md="4"-->
              <!--              >-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="houseNumber"-->
              <!--                  rules="required"-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="Huisnummer"-->
              <!--                    label-for="houseNumber"-->
              <!--                  >-->
              <!--                    <b-form-input-->
              <!--                      id="houseNumber"-->
              <!--                      v-model="calculation.houseNumber"-->
              <!--                      :state="getValidationState(validationContext)"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <!--              <b-col-->
              <!--                cols="12"-->
              <!--                md="4"-->
              <!--              >-->
              <!--                &lt;!&ndash; Country &ndash;&gt;-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="country"-->
              <!--                  rules="required"-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="Land"-->
              <!--                    label-for="country"-->
              <!--                    :state="getValidationState(validationContext)"-->
              <!--                  >-->
              <!--                    <v-select-->
              <!--                      v-model="calculation.country"-->
              <!--                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
              <!--                      :options="countryList"-->
              <!--                      :reduce="val => val.code"-->
              <!--                      :clearable="true"-->
              <!--                      label="name"-->
              <!--                      :state="getValidationState(validationContext)"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <!--              <b-col-->
              <!--                v-if="calculation.country === 'SR'"-->
              <!--                cols="12"-->
              <!--                md="4"-->
              <!--              >-->
              <!--                &lt;!&ndash; Country &ndash;&gt;-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="city"-->
              <!--                  rules="required"-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="Plaats"-->
              <!--                    label-for="city"-->
              <!--                    :state="getValidationState(validationContext)"-->
              <!--                  >-->
              <!--                    <v-select-->
              <!--                      v-model="calculation.city"-->
              <!--                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
              <!--                      :options="surinameCityList"-->
              <!--                      :reduce="val => val.code"-->
              <!--                      :clearable="true"-->
              <!--                      label="name"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <!--              <b-col-->
              <!--                v-else-->
              <!--                cols="12"-->
              <!--                md="4"-->
              <!--              >-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="city"-->
              <!--                  rules=""-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="Plaats"-->
              <!--                    label-for="city"-->
              <!--                  >-->
              <!--                    <b-form-input-->
              <!--                      id="city"-->
              <!--                      v-model="calculation.city"-->
              <!--                      :state="getValidationState(validationContext)"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <!--              <b-col-->
              <!--                v-if="calculation.country === 'SR'"-->
              <!--                cols="12"-->
              <!--                md="4"-->
              <!--              >-->
              <!--                &lt;!&ndash; District&ndash;&gt;-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="district"-->
              <!--                  rules="required"-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="District"-->
              <!--                    label-for="district"-->
              <!--                    :state="getValidationState(validationContext)"-->
              <!--                  >-->
              <!--                    <v-select-->
              <!--                      v-model="calculation.district"-->
              <!--                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
              <!--                      :options="districtsList"-->
              <!--                      :reduce="val => val.value"-->
              <!--                      :clearable="true"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <!--              <b-col-->
              <!--                v-else-->
              <!--                cols="12"-->
              <!--                md="4"-->
              <!--              >-->
              <!--                <validation-provider-->
              <!--                  #default="validationContext"-->
              <!--                  name="district"-->
              <!--                  rules=""-->
              <!--                >-->
              <!--                  <b-form-group-->
              <!--                    label="District"-->
              <!--                    label-for="district"-->
              <!--                  >-->
              <!--                    <b-form-input-->
              <!--                      id="district"-->
              <!--                      v-model="calculation.district"-->
              <!--                      :state="getValidationState(validationContext)"-->
              <!--                    />-->
              <!--                    <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
              <!--                      {{ validationContext.errors[0] }}-->
              <!--                    </b-form-invalid-feedback>-->
              <!--                  </b-form-group>-->
              <!--                </validation-provider>-->
              <!--              </b-col>-->
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="phone"
                  rules="required|integer|min:6"
                >
                  <b-form-group
                    label="Telefoonnummer"
                    label-for="phone"
                  >
                    <b-form-input
                      id="phone"
                      v-model="calculation.phoneNumber"
                      type="text"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="email"
                  rules="required|email"
                >
                  <b-form-group
                    label="E-mailadres"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="calculation.email"
                      type="email"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
      </form-wizard>
    </b-col>
  </b-row>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BRow,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import VueRadioButton from '@/views/components/VueRadioButton.vue'
import { countryList, districtsList, surinameCityList } from '@core/utils/list'
import Ripple from 'vue-ripple-directive'
import roStoreModule from '@/views/pages/ro/roStoreModule'
import { heightTransition } from '@core/mixins/ui/transition'
import {
  datePlusDays, formatDateTime, formatPrice, todayPlusDays,
} from '@core/utils/utils'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    flatPickr,
    BFormInvalidFeedback,
    BBadge,
    BCardBody,
    BFormInput,
    BCard,
    BCardText,
    BButton,
    VueRadioButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      todayPlusDays,
      trHeightBirthDate: 0,
      calculation: {
        destination: null,
        birthDates: [
          {
            birthDate: null,
          },
        ],
        premium: null,
        currency: null,
        dateFrom: null,
        dateTill: null,
        emailText: null,
      },
      blankCalculation: {
        destination: null,
        birthDates: [
          {
            birthDate: null,
          },
        ],
        premium: null,
        currency: null,
        dateFrom: null,
        dateTill: null,
        emailText: null,
      },
      dateFromConfig: {
        minDate: 'today',
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        altInput: true,
        allowInput: true,
      },
      birthDateConfig: {
        maxDate: 'today',
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        altInput: true,
        allowInput: true,
      },
      destinationButtons: [
        {
          id: 'WORLDWIDE',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/earth-americas.svg'),
          title: 'Wereldwijd',
          key: 'destination',
        },
        {
          id: 'EUROPE',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/earth-europa.svg'),
          title: 'Europa',
          key: 'destination',
        },
      ],
    }
  },
  computed: {
    dateTillConfig() {
      return {
        minDate: 'today',
        maxDate: this.calculation.dateFrom ? datePlusDays(this.calculation.dateFrom, 179) : null,
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        altInput: true,
        allowInput: true,
      }
    },
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addPerson() {
      this.calculation.birthDates.push(
        {
          birthDate: null,
        },
      )
      this.trHeightBirthDate = this.getHeight(this.$refs.rowBirthDates[0].offsetHeight)
    },
    resetForm() {
      this.calculation = JSON.parse(JSON.stringify(this.blankCalculation))
      this.$refs.birthDates.reset()
      this.$refs.information.reset()
      this.$refs.offer.reset()
      this.$refs.refWizard.reset()
    },
    setPzsType(type) {
      this.calculation.pzsType = type
    },
    validationInsuranceTypeForm() {
      return new Promise((resolve, reject) => {
        this.$refs.insuranceType.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationPersonForm() {
      return new Promise((resolve, reject) => {
        this.$refs.birthDates.validate().then(success => {
          if (success) {
            store.dispatch('app-ro/calculate', {
              birthDates: this.calculation.birthDates,
              destination: this.calculation.destination,
              startDate: this.calculation.dateFrom,
              endDate: this.calculation.dateTill,
            })
              .then(response => {
                this.calculation.currency = response.data.currency
                this.calculation.premium = new Intl.NumberFormat('nl-NL', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(response.data.premium)
                resolve(true)
              })
              .catch(() => {
                reject()
              })
          } else {
            reject()
          }
        })
      })
    },
    validationInformationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.information.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    formSubmitted() {
      this.$refs.offer.validate().then(success => {
        if (success) {
          this.calculation.emailText = `
          <h3>Reisverzekering</h3
          Vertrek op: ${this.calculation.dateFrom ? formatDateTime(this.calculation.dateFrom) : ''} <br/>
          Terug op: ${this.calculation.dateTill ? formatDateTime(this.calculation.dateTill) : ''} <br/>
          Bestemming: ${this.calculation.destination ? this.destinationButtons.filter(f => String(f.id) === String(this.calculation.destination))[0].title : ''} <br/>
          Personen: ${this.calculation.birthDates ? JSON.stringify(this.calculation.birthDates) : ''}<br/>
          Premie indicatie: ${this.calculation.premium ? this.calculation.premium : ''}
          `
          store.dispatch('app-ro/sendOfferMail', this.calculation)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Offerte aanvraag!',
                text: 'Bedankt voor uw offerte aanvraag, wij zullen spoedig contact met u opnemen.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.resetForm()
              })
            })
            .catch(() => {
              this.$swal({
                icon: 'error',
                title: 'Relatie!',
                text: 'Er is een fout opgetreden bij het verwerken van uw offerte aanvraag. Probeer het later nog een keer.',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              })
            })
        }
      })
    },
    removeInvoiceLine(index) {
      this.calculation.birthDates.splice(index, 1)
      this.trHeightBirthDate = this.getHeight(this.$refs.rowBirthDates[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        if (this.$refs.formBirthDate) {
          this.trHeightBirthDate = this.getHeight(this.$refs.formBirthDate.scrollHeight)
        }
      })
    },
    getHeight(val) {
      if (val === null) {
        this.trHeight = 'auto'
      } else {
        this.trHeight = `${Number(val)}px`
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
  setup() {
    const PZS_MODULE_NAME = 'app-ro'

    // Register module
    if (!store.hasModule(PZS_MODULE_NAME)) store.registerModule(PZS_MODULE_NAME, roStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PZS_MODULE_NAME)) store.unregisterModule(PZS_MODULE_NAME)
    })

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(() => {
    })

    return {
      refFormObserver,
      getValidationState,
      required,
      countryList,
      surinameCityList,
      districtsList,
      formatPrice,
      formatDateTime,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.v-radio-label {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  margin: 5px;
  border-radius: 4px;
  //border: 1px solid #eee;
  transition: all 500ms;
  background: rgba(253, 184, 19, 0.12);
  color: #000000;
  font-weight: bold;
  font-size: 12px;
}

.v-radio-active {
  //border: 2px solid #ce2a56;
  background-color: rgba(253, 184, 19, 0.4);
  //box-shadow: 0 1px 5px 0 rgba(206, 42, 86,.12); // #ce2a56 //#f3f2ee
  color: #000000;
  //img {
  //  filter: invert(100%) sepia(53%) saturate(1530%) hue-rotate(290deg) brightness(118%) contrast(102%);
  //}
}
</style>
<style lang="scss" scoped>
.form-group.is-invalid {
  ::v-deep .form-control {
    border-color: #ea5455 !important;
  }
}

.invalid {
  .card-title {
    color: #ea5455
  }
}
</style>
